<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
     
    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card  (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
               Etiketler
              </ng-container>
              <ng-container mCardBody>
                 <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Etiket Ara (aramak için ilaç adı yazıp enter tuşuna basınız)</label>
                      <input type="text" [(ngModel)]="search" class="form-control" (change)="ara()">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Onay Durumu</label>
                      <select class="form-control" [(ngModel)]="accepted" (change)="getLabels()">
                        <option value="1">Hepsi</option>
                        <option value="2">Onaylı</option>
                        <option value="3">Onaysız</option>
                      </select>
                  </div>
               </div>
                 
                </div>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Onay Durumu</th>
                          <th>Müstahzar</th>
                          <th>Barkod</th>
                       
                          <th>İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let label of labels">
                          <td>
                            <i class="la la-check success" *ngIf="label.accepted;else degil"></i>
                            <ng-template #degil><i class="la la-remove danger"></i></ng-template>
                           </td>
                          <td>{{label.name}}</td>
                          <td>{{label.barcode}}</td>
                          
                          <td>
                          <a routerLink="/detay/{{label.id}}" title="düzenle"><i class="la la-edit success" ></i></a> 
                            
                          </td>
                        </tr>
                      </tbody>
                       <tfoot>
                        <tr>
                          <td colspan="4">
                            <button class="btn btn-primary" (click)="prev()"><<</button>
                            <button class="btn">{{page}}</button>
                            <button class="btn btn-primary" (click)="next()">>></button>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
               
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
